<template>
  <div class="solution-list">
    <div v-ripple v-for="(solution, index) in solutions"
                            :key="index"
                            :class="['solution-list-item', {'solution-list-item--fixed': solution.dailyUnitYn == 'Y'}
                                      , {'complete': solution.cmpltYn}, {'current': solution.dailyUnitYn != 'Y' && currentPlanIndex === index}]"
                            @click="unitDetail(solution.unitUseNo, solution.freeYn, index, currentPlanIndex, solution.cmpltYn, solution.lock)"
                            >
      <v-avatar>
        <v-img :src="getImage(solution.helpfulIcon)"/>
      </v-avatar>
      <div class="unit-info">
        <b class="unit-name">
          <IconLock v-if="solution.lock"/>
          {{solution.unitNm}}
        </b>
        <span v-if="solution.unitTypeNm !== '' && solution.unitTypeCnt-1 <= 0" class="unit-type">{{solution.unitTypeNm}}</span>
        <span v-else-if="solution.unitTypeNm !== '' && solution.unitTypeCnt-1 > 0" class="unit-type">{{solution.unitTypeNm}} + {{solution.unitTypeCnt-1}}</span>
      </div>
    </div>

    <!-- v-for item -->
    <!-- solution-list-item--fixed : 마음날씨, 마음노트 (고정형) 일 경우 -->
    <!-- complete : 완료한 미션 -->
    <!-- current : 진행 가능 한 미션 (고정 유닛에는 추가 하면 X) -->
<!--    <div v-ripple-->
<!--         class="solution-list-item"-->
<!--         :class="[-->
<!--             'solution-list-item&#45;&#45;fixed',-->
<!--             'complete',-->
<!--             'current'-->
<!--         ]"-->
<!--    >-->
<!--      <v-avatar>-->
<!--        <v-img :src="require('@/assets/images/ic_condition_01.svg')" />-->
<!--      </v-avatar>-->
<!--      <div class="unit-info">-->
<!--        <b class="unit-name">-->
<!--          &lt;!&ndash; 잠긴 미션 &ndash;&gt;-->
<!--          <IconLock />-->
<!--          &lt;!&ndash; // 잠긴 미션 &ndash;&gt;-->
<!--          유닛 이름 2줄이상 말줄임 처리-->
<!--        </b>-->
<!--        <span class="unit-type">유닛타입 + 3</span>-->
<!--      </div>-->
<!--    </div>-->
    <!-- // v-for item -->

  </div>
</template>

<script>
import store from '../../store'
import IconLock from '@/components/icons/Lock'
import {mixinRemote, mixinTrial} from "@/mixins";
export default {
  mixins: [
    mixinRemote, mixinTrial
  ],
  components: {
    IconLock
  },
  async created () {
    await store.dispatch('getTodayPlanList', this.isApplResult === 'success')
  },
  methods:{}
}
</script>
